import { FC } from 'react';

const iconForefinger = require('./icon_forefinger.svg');

export const IconForefinger: FC = () => {
  return <img alt="icon_forefinger" height={86} src={iconForefinger} width={78} />;
};

IconForefinger.displayName = 'IconForefinger';
